// BonBoZ: đọc chuỗi dịch từ một helper chạy NGOÀI component Vue.
//
// `useI18n` chỉ gọi được trong `setup()`. Helper như `pushHelper.js` chạy ngoài
// vòng đời component nên phải đọc thẳng bảng dịch. Ngôn ngữ lấy từ
// `<html lang>` — App.vue ghi vào đó mỗi lần đổi ngôn ngữ.
import i18nMessages from 'dashboard/i18n';

export const translate = key => {
  const messages =
    i18nMessages[document.documentElement.lang] || i18nMessages.en;
  return key.split('.').reduce((node, part) => node?.[part], messages) || '';
};
